import { OptimizelyExperiments } from 'constants/optimizely'
import { getOptimizelyExperimentVariation } from 'lib/optimizely/optimizelyUtils'

export const isOfferEndingSoonCarouselEnabled = (state: App.State) => !!getOptimizelyExperimentVariation(state, OptimizelyExperiments.croOffersEndingSoonCarousel)
